export default {
  title: 'Détails du prix',
  subtotal: 'Sous-total',
  method_fee: 'Frais de livraison',
  tip: 'Pourboire',
  service_fee: 'Traitement en ligne',
  payment_method_upcharge_fee: 'Frais PayPal',
  discount: 'Réduction',
  taxes: 'Taxes',
  total: 'Total',
};
